(function () {
  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    // Older browsers and non-HTTPS previews: select a hidden field and copy it.
    return new Promise(function (resolve, reject) {
      var field = document.createElement('textarea');
      field.value = text;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();
      try {
        document.execCommand('copy') ? resolve() : reject(new Error('copy failed'));
      } catch (error) {
        reject(error);
      } finally {
        document.body.removeChild(field);
      }
    });
  }

  function init(root) {
    var dialog = root.querySelector('[data-share-dialog]');
    var openButton = root.querySelector('[data-share-open]');
    if (!dialog || !openButton || typeof dialog.showModal !== 'function') return;

    var url = root.dataset.shareUrl;
    var title = root.dataset.shareTitle;
    var toast = dialog.querySelector('[data-share-toast]');
    var toastTimer = null;

    function say(message) {
      if (!toast) return;
      toast.textContent = message;
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () {
        toast.textContent = '';
      }, 3000);
    }

    function copyLink(appName) {
      return copyText(url).then(
        function () {
          say(appName ? 'Link copied — paste it into ' + appName + '.' : 'Link copied.');
        },
        function () {
          say('Could not copy the link.');
        }
      );
    }

    openButton.addEventListener('click', function () {
      dialog.showModal();
      // The page behind would otherwise scroll under the popup.
      document.documentElement.style.overflow = 'hidden';
    });

    dialog.addEventListener('close', function () {
      document.documentElement.style.overflow = '';
      if (toast) toast.textContent = '';
      openButton.focus();
    });

    dialog.querySelector('[data-share-close]').addEventListener('click', function () {
      dialog.close();
    });

    // The dialog is sized to the viewport and the panel sits inside it, so a
    // click that lands on the dialog itself is a click on the backdrop.
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });

    dialog.querySelector('[data-share-copy]').addEventListener('click', function () {
      copyLink();
    });

    // WeChat, Instagram and TikTok have no web share URL. On a phone the
    // system share sheet can reach those apps directly; elsewhere the link is
    // copied with a pointer to where it goes.
    dialog.querySelectorAll('[data-share-app]').forEach(function (button) {
      button.addEventListener('click', function () {
        var app = button.dataset.shareApp;
        if (navigator.share) {
          navigator.share({ title: title, url: url }).catch(function (error) {
            // Cancelling the share sheet is not a failure worth reporting.
            if (error && error.name !== 'AbortError') copyLink(app);
          });
        } else {
          copyLink(app);
        }
      });
    });
  }

  document.querySelectorAll('[data-article-share]').forEach(init);
})();
